import clsx from 'clsx';
import { type ReactNode, useEffect, useRef } from 'react';
import { style } from './error-popup.module.css';

interface Props {
  open: boolean;
  children: ReactNode;
  onClose: () => void;
}

export function ErrorPopup(props: Props) {

  const {
    open,
    children,
    onClose
  } = props;

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {

    if (!open) return;

    const handleClick = (event: MouseEvent) => {
      const rect = ref.current!.getBoundingClientRect();
      if (event.x < rect.x || event.x > rect.right || event.y < rect.y || event.y > rect.bottom) {
        onClose();
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [open, onClose]);

  return (
    <div 
      ref={ref}
      className={clsx(style.container, open && style.open)}>
      <div className={style.arrow}/>
      <div className={style.content}>
        {children}
      </div>
    </div>
  );
}
